import { IStairConfig, IStepGeometry, IStringerGeometry } from '@stair-craft/common/util';

import { generateKosourStringer } from '../straight-generate-kosour-stringer/generate-kosour-stringer';
import { generateTetivaStringer } from '../straight-generate-tetiva-stringer/generate-tetiva-stringer';

/**
 * The pair of side stringers for a straight flight — кosour (sawtooth) or тетива
 * (flat plank) per `config.stringerType`, one on each side of the stair.
 */
export function generateStringers(steps: IStepGeometry[], config: IStairConfig, riserHeight: number): IStringerGeometry[] {
    if (config.stringerType === 'kosour') {
        return [generateKosourStringer(steps, config, riserHeight, 'left'), generateKosourStringer(steps, config, riserHeight, 'right')];
    }
    return [generateTetivaStringer(steps, config, riserHeight, 'left'), generateTetivaStringer(steps, config, riserHeight, 'right')];
}
